function formatImageUrl(image) {
    const [baseUrl, imagePath] = image.variant_img_url.split("/images/");
    const updatedPath = imagePath.replace(imagePath.split("/")[0], "w_100,h_100,c_fit");
    return `${baseUrl}/images/${updatedPath}`;
}

function generateImageElement(image, className) {
    const img = document.createElement('img');
    img.classList.add(className, 'lazyautosizes', 'lazyloaded', 'hover');
    img.width = 100;
    img.height = 100;
    img.dataset.sizes = "auto";
    img.src = formatImageUrl(image);
    img.alt = image.variant_img_alttext;
    img.sizes = "70px";
    return img;

}

function generateNoscriptElement(image) {
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.width = 100;
    img.height = 100;
    img.sizes = "auto";
    img.src = formatImageUrl(image);
    img.alt = image.variant_img_alttext;
    img.loading = "lazy";
    noscript.appendChild(img);
    return noscript;
}

function generateProductCard(product,color) {
    //get id and title from product
    const {id, title, variant, handle, priceRangeV2} = product;
    const {price, images, variantId} = variant;


    const div = document.createElement('li');
    //add class to div
    div.classList.add('column');
    //create product-card element
    const product_card = document.createElement('product-card');
    //add list of classes to product-card element
    product_card.classList.add('product-card', 'text-center');
    //create figure element
    const figure = document.createElement('figure');
    //add class to figure element
    figure.classList.add('product-featured-image', 'thb-hover');
    //create a element
    const a = document.createElement('a');
    //add href to a element
    a.href = `/products/${handle}?variant=${variantId}`;
    //add title to a element
    a.title = title;
    //add class to a element
    a.classList.add('product-featured-image-link', 'aspect-ratio', 'aspect-ratio--adapt');
    //add style to a element
    a.style = "--padding-bottom: 100.0%;";

    //create button element
    const button = document.createElement('button');
    //add class to button element
    button.classList.add('product-card-quickview');
    button.setAttribute('data-color', color);
    //add href to button element
    // button.href = "#Product-Drawer";
    //add attribute to button element
    button.setAttribute('href', '#Product-Drawer');
    //add data-product-handle to button element
    button.dataset.productHandle = handle;
    //add tabindex to button element
    button.tabIndex = -1;
    //create div element
    const div2 = document.createElement('div');
    //add class to div element
    div2.classList.add('loading-overlay');
    div2.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewbox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle></svg>';
    //create span element
    const span = document.createElement('span');
    //add text to span
    span.innerText = "Quick view";
    //append span to button
    button.appendChild(div2);
    //append span to button
    button.appendChild(span);
    //create ul element
    const ul = document.createElement('ul');
    //add class to ul element
/*    ul.classList.add('product-secondary-images-nav');
    //create li element
    images.forEach(image => {
        const li = document.createElement('li');
        ul.appendChild(li);
    })*/
    //append ul to a

    //loop through images
/*    images.forEach(image => {
        //check is last image
        const className = images.indexOf(image) === images.length - 1 ? "product-primary-image" : "product-secondary-image";
        a.appendChild(generateImageElement(image, className));
        a.appendChild(generateNoscriptElement(image));
    })*/

    a.appendChild(generateImageElement(images[0], "product-primary-image--lazy"));
    a.appendChild(generateNoscriptElement(images[0]));


    //append button to a
    a.appendChild(button);
    //append ul to a
    //a.appendChild(ul);
    //append a to figure
    figure.appendChild(a);
    //create div element
    const div3 = document.createElement('div');
    //add class to div element
    div3.classList.add('product-card-info');
    //create a element
    const a2 = document.createElement('a');
    //add href to a element
    a2.href = `/products/${handle}?variant=${variantId}`;
    //add title to a element
    a2.title = title;
    //add class to a element
    a2.classList.add('product-card-title');
    //add text to a2
    a2.innerText = title;
    //create span element
    const span2 = document.createElement('span');
    //add class to span element
    span2.classList.add('price');
    //create ins element
    const ins = document.createElement('ins');
    //create span element
    const span3 = document.createElement('span');
    //add class to span element
    span3.classList.add('amount');
    //create span element
    const span4 = document.createElement('span');
    //add class to span element
    span4.classList.add('from');
    //add text to span4
    span4.innerText = "From ";
    //add text to span3
    span3.innerText = `${priceRangeV2.minVariantPrice.currencyCode} ${price}`;
    //prepend span4 to span3
    span3.prepend(span4);
    //append span3 to ins
    ins.appendChild(span3);
    //append ins to span2
    span2.appendChild(ins);
    //append span2 to div3
    div3.appendChild(a2);
    //append span2 to div3
    div3.appendChild(span2);
    //append div3 to product_card
    product_card.appendChild(figure);
    //append div3 to product_card
    product_card.appendChild(div3);
    //append product_card to div
    div.appendChild(product_card);
    return div;
}

function loadGWWProducts(tag, color) {
    document.getElementById('filtered-products').innerHTML = '';
    fetch(`https://jqueen.hyquality.com/api/products/${tag}/${color}/250`).then(response => response.text()).then((responseText) => {
        //parse response text to JSON
        const products = JSON.parse(responseText);
        //loop through products
        document.getElementById('filtered-products').classList.add('filtered-products--active');
        const ul = document.createElement('ul');
        //check if products is empty and hide filtered-products
        if (products.length === 0) {
            document.getElementById('filtered-products').style.display = 'none';
            return;
        }
        products.forEach(product => {
            //generate product card
            if(document.querySelector('.product-title-container .product-title').textContent!==product.title){
                const card = generateProductCard(product,color);
                //append card to filtered-products
                ul.appendChild(card);
            }

        });
        //check if ul has children and append to filtered
        if (ul.children.length === 0) {
            document.getElementById('filtered-products').style.display = 'none';
            return;
        }
        document.getElementById('filtered-products').appendChild(ul);
    });
}
